import { uploadBlobDirect, shouldUploadBlobDirect } from "./uploadBlobDirect";
import { uploadImage } from "./UploadImage";

export async function uploadHelpCenterFile(
  file: File,
  sectionId: string,
): Promise<string | undefined> {
  if (shouldUploadBlobDirect(file)) {
    return uploadBlobDirect(file, sectionId, "help-center/");
  }

  return uploadImage(file, sectionId, "help-center/");
}
